// @see: https://github.com/sciactive/pnotify

window.PNotify = require("@pnotify/core/dist/PNotify"); // import PNotify from '@pnotify/core';

import {Stack, defaults, defaultModules} from "@pnotify/core";
import * as PNotifyMobile from '@pnotify/mobile';
import * as PNotifyCountdown from '@pnotify/countdown';
// import * as PNotifyAnimate from "@pnotify/animate";

defaultModules.set(PNotifyMobile, {});

// import * as PNotifyBootstrap4 from "@pnotify/bootstrap4";
// import * as PNotifyFontAwesome5Fix from "@pnotify/font-awesome5-fix";
// import * as PNotifyFontAwesome5 from "@pnotify/font-awesome5";

// defaultModules.set(PNotifyBootstrap4, {});
// defaultModules.set(PNotifyFontAwesome5Fix, {});
// defaultModules.set(PNotifyFontAwesome5, {});

window.defaultStack = new Stack({
    dir1:        'up',
    dir2:        'left',
    firstpos1:   25,
    firstpos2:   25,
    spacing1:    36,
    spacing2:    36,
    push:        'bottom',
    maxStrategy: 'close',
    context:     document.body
});

defaults.stack        = defaultStack;
defaults.titleTrusted = true;
defaults.textTrusted  = true;
defaults.mode         = 'light';
defaults.delay        = 3000;
defaults.maxOpen      = Infinity;
defaults.modules      = new Map([
    ...defaultModules,
    [
        // PNotifyAnimate,
        // {
        //     inClass:  'bounceInLeft',
        //     outClass: 'bounceOutRight',
        // },
        PNotifyCountdown,
        {
            // Countdown Module Options
        },
    ],
]);

/**
 * Show Alert Success by PNotify.
 *
 * @param      {string}  text    The text to show on body alert.
 */
window.pNotifySuccess = function (text) {
    window.notice = PNotify.success({
        title: `<b>${transAccionExito}</b>`,
        text:  text,
    });
}

/**
 * Show Alert Warning by PNotify.
 *
 * @param      {string}  text    The text to show on body alert.
 */
window.pNotifyWarning = function (text) {
    window.notice = PNotify.notice({
        title: `<b>${transAccionAtencion}</b>`,
        text:  text,
    });
}

/**
 * Show Alert Error by PNotify.
 *
 * @param      {string}  text    The text to show on body alert.
 */
window.pNotifyError = function (text) {
    window.notice = PNotify.error({
        title: `<b>${transAccionAtencion}</b>`,
        text:  text,
    });
}

/**
 * Show Alert No Connection Error by PNotify.
 */
window.pNotifyErrorConnection = function () {
    pNotifyError(transErrorServer);
}
